import { BreadcrumbProvider } from "@/ui-components/ui/breadcrumb/breadcrumb-context";
import DynamicBreadcrumb from "@/ui-components/ui/breadcrumb/breadcrumb-url";
import GlobalSearch from "@/ui-components/ui/global-search";
import SideMenu from "@/ui-components/utils/menu-items/side-menu";
import TopBar from "@/ui-components/utils/menu-items/top-bar";
import { Video } from "lucide-react";
import { ReactElement } from "react";

export interface HelpVideo {
  id: number;
  title: string;
  description: string;
  loomId: string;
  type: "video";
}

export const mockedHelpArticles: HelpVideo[] = [
  {
    id: 1,
    title: "Mein Account",
    description:
      "",
    loomId: "41474099d3d64a888c4e9da5ac67622b",
    type: "video",
  },
  {
    id: 2,
    title: "Kontakte verwalten",
    description:
      "",
    loomId: "9f9c9b1d9c1d43258621b9e91afb6ce0",
    type: "video",
  },
  {
    id: 3,
    title: "Deal Verwaltung und Pipelines",
    description:
      "",
    loomId: "03ff318b716c4a9993a8ea051d46921e",
    type: "video",
  },
  {
    id: 4,
    title: "Verkäufe",
    description:
      "",
    loomId: "d429a04f72174301b12fcf2986e6b3ac",
    type: "video",
  }
];

const HelpRootComponent = ({ children }: { children: ReactElement }) => {
  return (
    <div className="flex flex-col h-full">
      <BreadcrumbProvider>
        <TopBar>
          <>
            <DynamicBreadcrumb />
            <GlobalSearch />
            <div className="flex-1"></div>
          </>
        </TopBar>
        <div className="flex grow">
          <SideMenu
            items={mockedHelpArticles.map((article) => ({
              title: article.title,
              icon: <Video className="text-[#1059E6]" />,
              link: `/help?id=${article.id}`,
            }))}
          />
          <div className="grow">{children}</div>
        </div>
      </BreadcrumbProvider>
    </div>
  );
};

export default HelpRootComponent;
